const React = require('react')
const withStyles = require('withStyles').default
const styles = require('./mobile_nav.less')
const { NotProComponent } = require('component/viewer/not_pro')

// TODO modify this file to reuse nav/anonymous_links and nav/viewer_links?
// have to decide between duplication vs. over-coupling

function MobileNav() {
    return (
        <nav className="mobile-nav">
            <ul>
                <li><a href="/">Home</a></li>
                <NotProComponent>
                    <li>
                        <a
                            href="/features"
                            data-metric-channel="metrics_nav"
                            data-metric-event="clicked:features"
                            >
                            Features
                        </a>
                    </li>
                    <li>
                        <a
                            href="/pricing"
                            data-metric-channel="metrics_nav"
                            data-metric-event="clicked:pricing"
                            >
                            Pricing
                        </a>
                    </li>
                </NotProComponent>
            </ul>
        </nav>
    )
}

module.exports = withStyles(styles)(MobileNav)
